var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoint3Icon11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "point3icon1-1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70.829,
    height: 87.173,
    viewBox: "0 0 70.829 87.173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_102",
    "data-name": "\\u9577\\u65B9\\u5F62 102",
    width: 70.829,
    height: 87.173,
    fill: "#5f7cae"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_80",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 80",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_100",
    "data-name": "\\u30D1\\u30B9 100",
    d: "M34.366,222.99A43.073,43.073,0,0,1,4.643,210.772c-1.787-1.7-1.6-3.944.345-4.687,1.381-.526,2.375.165,3.323,1.078a36.291,36.291,0,0,0,16.523,9.313c13.665,3.417,25.749.311,36.241-9.061.254-.226.486-.477.744-.7a2.556,2.556,0,0,1,3.653-.074,2.483,2.483,0,0,1-.146,3.762,40.646,40.646,0,0,1-3.551,3.164,43.444,43.444,0,0,1-27.411,9.422",
    transform: "translate(-2.248 -135.817)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_101",
    "data-name": "\\u30D1\\u30B9 101",
    d: "M66.579,14.623c-.789.876-1.3,1.948-2.025,2.12a4.06,4.06,0,0,1-2.894-.607c-2.936-2-5.557-4.526-8.635-6.246A37.951,37.951,0,0,0,8.862,15.158c-.418.383-.816.79-1.254,1.148a2.574,2.574,0,0,1-3.658-.041,2.456,2.456,0,0,1,.165-3.645A49.884,49.884,0,0,1,8.733,8.614,43.4,43.4,0,0,1,64.54,11.906a21.918,21.918,0,0,1,2.038,2.718",
    transform: "translate(-2.123 0)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_102",
    "data-name": "\\u30D1\\u30B9 102",
    d: "M83.628,103.32A12.764,12.764,0,1,1,70.907,90.544,12.718,12.718,0,0,1,83.628,103.32m-5.113.045a7.592,7.592,0,0,0-7.6-7.7,7.629,7.629,0,0,0-.136,15.257,7.59,7.59,0,0,0,7.741-7.56",
    transform: "translate(-38.324 -59.724)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_103",
    "data-name": "\\u30D1\\u30B9 103",
    d: "M49.294,198.835c-9.294-.219-17.048-3.15-23.489-9.324-1.408-1.35-1.578-2.907-.494-4.021,1.054-1.083,2.644-.938,4.054.369,11.245,10.426,27.537,10.455,38.765.07,1.483-1.372,2.94-1.555,4.055-.51,1.172,1.1,1.139,2.58-.183,3.879a32.463,32.463,0,0,1-18.567,9.146c-1.511.218-3.043.291-4.14.391",
    transform: "translate(-16.231 -121.864)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_104",
    "data-name": "\\u30D1\\u30B9 104",
    d: "M48.812,29.919a33.178,33.178,0,0,1,22.8,9.156c1.624,1.536,1.839,2.871.7,4.113-1.084,1.177-2.655,1.041-4.172-.362a27.968,27.968,0,0,0-38.765.046c-1.416,1.315-2.995,1.469-4.056.4-1.129-1.142-.927-2.7.59-4.14a33.193,33.193,0,0,1,22.9-9.208",
    transform: "translate(-16.226 -19.735)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_105",
    "data-name": "\\u30D1\\u30B9 105",
    d: "M61.941,59.891c6.839.14,12.112,2.127,16.543,6.228,1.51,1.4,1.688,2.991.543,4.138-1.11,1.112-2.5.97-4.029-.411a17.823,17.823,0,0,0-23.977-.362c-.259.22-.5.457-.762.676a2.616,2.616,0,0,1-3.785.02,2.676,2.676,0,0,1,.348-3.79,22.083,22.083,0,0,1,10.413-5.749c1.806-.421,3.671-.591,4.707-.751",
    transform: "translate(-30.235 -39.505)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_106",
    "data-name": "\\u30D1\\u30B9 106",
    d: "M62.849,174.583a23.33,23.33,0,0,1-15.539-6.022c-1.59-1.418-1.9-3.078-.816-4.262,1.068-1.167,2.543-1.03,4.161.385,7.37,6.444,17.147,6.376,24.485-.17,1.417-1.264,2.831-1.362,3.908-.27,1.1,1.113.954,2.695-.447,4.015a22.946,22.946,0,0,1-15.753,6.323",
    transform: "translate(-30.247 -107.842)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_107",
    "data-name": "\\u30D1\\u30B9 107",
    d: "M165.424,95.572c-1.194,0-2.1.052-3-.011A2.428,2.428,0,0,1,159.854,93a2.39,2.39,0,0,1,2.635-2.49q5.608-.091,11.218.007a2.416,2.416,0,0,1,2.563,2.573,2.455,2.455,0,0,1-2.512,2.462c-1,.075-2.008.014-3.214.014,0,.85,0,1.459,0,2.067,0,5.1.011,10.2-.006,15.3-.007,1.959-.86,2.984-2.433,3.033-1.6.05-2.659-1.089-2.67-3.034-.029-5.1-.011-10.2-.011-15.3v-2.06",
    transform: "translate(-105.442 -59.672)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_108",
    "data-name": "\\u30D1\\u30B9 108",
    d: "M.006,104.766c0-3.111-.013-6.222,0-9.333.01-1.851.974-2.975,2.5-2.993,1.508-.017,2.588,1.152,2.594,2.943q.032,9.5,0,19a2.591,2.591,0,0,1-2.626,2.884C.975,117.238.027,116.19.013,114.438c-.025-3.224-.007-6.448-.007-9.672",
    transform: "translate(0 -60.975)",
    fill: "#5f7cae"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint3Icon11);
export default __webpack_public_path__ + "static/media/point3icon1-1.150e1385a6f8d2ca7d451c11d6f0b8c4.svg";
export { ForwardRef as ReactComponent };